import type { Control, FieldValues, Path } from "react-hook-form";

import NumberFlowInput from "./NumberFlow";

interface Props {
    control?: Control;
    name: string;
    label?: string;
    disabled?: boolean;
    tabIndex?: number;
    min?: number | null;
    max?: number | null;
    step?: number | string;
}

function numericBound(value: number | null | undefined): number | undefined {
    return value == null ? undefined : value;
}

function numericStep(step: number | string | undefined): number | undefined {
    if (step == null || step === "") return undefined;
    const parsed = typeof step === "string" ? Number(step) : step;
    return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}

const NumberInput = ({ name, label, disabled, tabIndex, min, max, step }: Props) => {
    return (
        <NumberFlowInput
            name={name as Path<FieldValues>}
            label={label}
            disabled={disabled}
            tabIndex={tabIndex}
            min={numericBound(min)}
            max={numericBound(max)}
            step={numericStep(step)}
            allowEmpty
            aria-label={label}
        />
    );
};

export default NumberInput;
